import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { summarizeVerifications, useSuiteVerifications } from '../services/suiteVerificationService';
import { useKnownFailures } from '../services/knownFailuresService';

const formatVerifiedAt = (iso) =>
  new Date(iso).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  });

/**
 * Bandeau affiché quand toutes les suites affichées (celles qui portent un
 * SuiteVerifyButton) ont leur run courant vérifié. Rien sinon.
 */
export default function AllSuitesVerifiedBanner({ suites, version }) {
  const verifications = useSuiteVerifications();
  const knownFailures = useKnownFailures(suites);

  if (!verifications) return null;
  const { total, verified: found, allVerified } = summarizeVerifications(verifications, suites, knownFailures);
  if (!allVerified) return null;

  const manual = found.filter(v => !v.auto);
  const noFailureCount = found.filter(v => v.reason === 'no-failure').length;
  const knownBugsCount = found.filter(v => v.reason === 'known-bugs').length;
  const verifiers = [...new Set(manual.map(v => v.verifiedBy))];
  const lastAt = manual.map(v => v.verifiedAt).sort().pop();
  const details = [
    manual.length > 0 && `Par ${verifiers.join(', ')} — dernière analyse le ${formatVerifiedAt(lastAt)}`,
    noFailureCount > 0 && (noFailureCount === 1 ? '1 run sans erreur' : `${noFailureCount} runs sans erreur`),
    knownBugsCount > 0 && (knownBugsCount === 1 ? '1 run aux échecs tous liés à un bug' : `${knownBugsCount} runs aux échecs tous liés à un bug`),
  ].filter(Boolean).join(' · ');

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-start gap-3">
      <ShieldCheck className="w-6 h-6 text-green-600 flex-shrink-0" />
      <div className="text-sm text-green-800">
        <p className="font-semibold">
          {total === 1
            ? 'La suite a été analysée'
            : `Les ${total} suites ont été analysées`}
          {version ? ` pour la version ${version}` : ''}
        </p>
        <p className="text-green-700 mt-0.5">
          {details}
        </p>
      </div>
    </div>
  );
}
